import React from "react";
import { MdError } from "react-icons/md";
import errorIcon from "assets/icons/error.svg";
const OFile = ({ type, src, fallbackUrl, ...rest }) => {
  return (
    <>
      {type === "video/mp4" || type === "video" ? (
        <video controls
          src={src}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = fallbackUrl ? fallbackUrl : errorIcon;
          }}
          {...rest}
        />
      ) : type === 'audio' ? (
        <audio controls>
          <source
            // type="audio/mpeg"
            src={src}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = fallbackUrl ? fallbackUrl : errorIcon;
            }}
            {...rest}
          />
        </audio>
      ) : (
        <img
          alt="img"
          src={src}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = fallbackUrl ? fallbackUrl : errorIcon;
          }}
          {...rest}
        />
      )}
    </>
  );
};

export default OFile;
